/**
 * @description 将base64 data url资源转成 blob 类型
 * @param {string} dataURI base64 data url
 * @returns {Blob} blob实例
 */
const base64ToBlob = (dataURI: string): Blob => {
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]; // mime类型
  const byteString = atob(dataURI.split(',')[1]); //base64 解码
  const arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
  const intArray = new Uint8Array(arrayBuffer); //创建视图

  for (let i = 0; i < byteString.length; i++) {
    intArray[i] = byteString.charCodeAt(i);
  }
  return new Blob([intArray], { type: mimeString });
};

export default base64ToBlob;
